import { Suspense } from 'react';
import { createFileRoute, notFound } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { MonitorInstituteSubjectsPage } from '@/features/question/pages/MonitorInstituteSubjectsPage';
import { monitorSubjectsSearchSchema } from '@/features/question/types/question.types';
import { parsePositiveIdParams } from '@/utils/routeParams';

export const Route = createFileRoute('/_auth/question/monitor/institutes/$projectInstituteId')({
  parseParams: (rawParams) => {
    const params = parsePositiveIdParams(rawParams);
    if (params === null) throw notFound();
    return params;
  },
  validateSearch: monitorSubjectsSearchSchema,
  component: function MonitorInstituteSubjectsRoute() {
    const { projectInstituteId } = Route.useParams();
    const search = Route.useSearch();
    return (
      <ErrorBoundary moduleName="Question Monitor Subjects">
        <Suspense fallback={<PageLoader />}>
          <MonitorInstituteSubjectsPage projectInstituteId={projectInstituteId} search={search} />
        </Suspense>
      </ErrorBoundary>
    );
  },
});
